import Cta from "../shared/Cta";

export default function Cta_() {
  return (
    <Cta
      title="Don't see the right role?"
      description="We're always looking for talented people who are passionate about EV charging and sustainable mobility. Send us your resume and we'll reach out when a fit opens up."
      buttonLabel="Get in Touch"
      buttonHref="mailto:career@verdemobility.com?subject=Resume%20Submission%20-%20General%20Interest"
      variant="morph"
    />
  );
}
